import React from 'react';
import { Link } from 'react-router-dom';

const Menunav = () => {
  return (
    <div className="relative">
      <div className="w-full bg-[#232F3E] border-t border-gray-200 border-gray-700">
        <div className="mx-auto max-w-screen-2xl lg:px-8 overflow-x-auto">
          <ul className="flex flex-wrap justify-center lg:gap-x-20 md:gap-x-15 py-4 text-base lg:text-md md:text-sm font-medium text-white text-center min-w-max">
            <li>
              <Link
                to="/category/toilet-cleaner"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Toilet Cleaner
              </Link>
            </li>

            <li>
              <Link
                to="/category/floor-cleaner"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Floor Cleaner
              </Link>
            </li>

            <li>
              <Link
                to="/category/surface-cleaner"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Surface Cleaner
              </Link>
            </li>

            {/* <li>
              <Link
                to="#dishWashGel"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Dish Wash Gel
              </Link>
            </li> */}

            {/* <li>
              <Link
                to="#sanitizerGel"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Sanitizer
              </Link>
            </li> */}

            <li>
              <Link
                to="/category/hand-wash"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Hand Wash
              </Link>
            </li>

            <li>
              <Link
                to="/category/dish-wash"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Dish Wash
              </Link>
            </li>

            <li>
              <Link
                to="/category/phenyl"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Phenyl
              </Link>
            </li>

            <li>
              <Link
                to="#media"
                className="transition-colors hover:border hover:border-white p-[15px] rounded"
              >
                Media
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menunav;